define("auth/controllers/user-goals", ["exports", "@ember/controller", "@ember/service", "@ember/object", "@glimmer/tracking", "@ember/utils", "ember-concurrency-decorators", "tracked-built-ins", "ember-concurrency-ts", "later/utils/user-goals"], function (_exports, _controller, _service, _object, _tracking, _utils, _emberConcurrencyDecorators, _trackedBuiltIns, _emberConcurrencyTs, _userGoals) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _questions, _qaQuestionIdentifierMap, _populateValidationErrors, _track, _findIndex;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

  function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

  function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

  function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

  function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let UserGoalsFormController = (_class = (_questions = /*#__PURE__*/new WeakMap(), _qaQuestionIdentifierMap = /*#__PURE__*/new WeakMap(), _populateValidationErrors = /*#__PURE__*/new WeakSet(), _track = /*#__PURE__*/new WeakSet(), _findIndex = /*#__PURE__*/new WeakSet(), class UserGoalsFormController extends _controller.default {
    get questions() {
      return _classPrivateFieldGet(this, _questions);
    }

    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _findIndex);

      _classPrivateMethodInitSpec(this, _track);

      _classPrivateMethodInitSpec(this, _populateValidationErrors);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "store", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "errors", _descriptor5, this);

      _initializerDefineProperty(this, "router", _descriptor6, this);

      _initializerDefineProperty(this, "hasABTestFlag", _descriptor7, this);

      _initializerDefineProperty(this, "showError", _descriptor8, this);

      _initializerDefineProperty(this, "validations", _descriptor9, this);

      _initializerDefineProperty(this, "bestDescribesAskedInPlansSignup", _descriptor10, this);

      _initializerDefineProperty(this, "answers", _descriptor11, this);

      _classPrivateFieldInitSpec(this, _questions, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldInitSpec(this, _qaQuestionIdentifierMap, {
        writable: true,
        value: {
          bestDescribes: 'bestDescribes',
          socialMediaGoal: 'socialGoal',
          goalWithLater: 'topGoal',
          whatEncouragedSignup: 'whatEncouragedSignup'
        }
      });

      this.bestDescribesAskedInPlansSignup = !!this.auth.currentAccount.bestDescribes;
      this.answers.bestDescribes.answer = this.auth.currentAccount.bestDescribes;

      _classPrivateFieldSet(this, _questions, (0, _userGoals.default)(this.intl));
    }

    *submit() {
      const {
        currentAccount,
        currentUserModel
      } = this.auth;

      _classPrivateMethodGet(this, _populateValidationErrors, _populateValidationErrors2).call(this, this.answers);

      if ((0, _utils.isPresent)(this.validations)) {
        this.showError = true;
        return;
      }

      yield (0, _emberConcurrencyTs.taskFor)(this.saveAnswers).perform();

      _classPrivateMethodGet(this, _track, _track2).call(this);

      yield (0, _emberConcurrencyTs.taskFor)(this.segment.identify).perform(currentUserModel.id, currentAccount.id);
      this.router.transitionTo('user.trial_plans');
    }

    *saveAnswers() {
      this.auth.currentAccount.setProperties({
        bestDescribes: this.answers.bestDescribes.answer,
        socialMediaGoal: "social_media_goal-".concat(this.answers.socialMediaGoal.answer),
        goalWithLater: "goal_with_later-".concat(this.answers.goalWithLater.answer),
        whatEncouragedSignup: this.answers.whatEncouragedSignup.answer
      });
      yield this.auth.currentAccount.save().catch(error => this.errors.handleAdapter(error));
    }

    selectOption(question, option) {
      this.answers[question].answer = option;
      this.answers[question].position = _classPrivateMethodGet(this, _findIndex, _findIndex2).call(this, question, option);
    }

    open(powerSelectApi) {
      if (!powerSelectApi.isOpen) {
        powerSelectApi.actions.open();
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasABTestFlag", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "validations", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedArray([]);
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "bestDescribesAskedInPlansSignup", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "answers", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {
        bestDescribes: new _trackedBuiltIns.TrackedObject({
          answer: null,
          position: null
        }),
        socialMediaGoal: new _trackedBuiltIns.TrackedObject({
          answer: null,
          position: null
        }),
        goalWithLater: new _trackedBuiltIns.TrackedObject({
          answer: null,
          position: null
        }),
        whatEncouragedSignup: new _trackedBuiltIns.TrackedObject({
          answer: null,
          position: null
        })
      };
    }
  }), _applyDecoratedDescriptor(_class.prototype, "submit", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveAnswers", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "saveAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectOption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype)), _class);
  _exports.default = UserGoalsFormController;

  function _populateValidationErrors2(answers) {
    this.validations.clear();
    Object.entries(answers).forEach(_ref => {
      let [question, {
        answer
      }] = _ref;

      if ((0, _utils.isEmpty)(answer)) {
        this.validations.push({
          questionIdentifier: _classPrivateFieldGet(this, _qaQuestionIdentifierMap)[question],
          text: this.questions[question].validationText
        });
      }
    });
  }

  function _track2() {
    this.segment.track('collected-user-goals-signup', {
      best_describes: this.answers.bestDescribes.answer,
      best_describes_position: this.answers.bestDescribes.position,
      social_media_goal: this.answers.socialMediaGoal.answer,
      social_media_goal_position: this.answers.socialMediaGoal.position,
      goal_with_later: this.answers.goalWithLater.answer,
      goal_with_later_position: this.answers.goalWithLater.position,
      what_encouraged_signup: this.answers.whatEncouragedSignup.answer,
      what_encouraged_signup_position: this.answers.whatEncouragedSignup.position
    });
  }

  function _findIndex2(question, option) {
    return this.questions[question].options.findIndex(opt => opt === option);
  }
});